import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import checkmark from './checkmark.svg';

export const CheckedBox = ({ removeFromCart, buttonBackground }) => (
  <span
    className={styles.checkedBox}
    style={buttonBackground}
    onClick={removeFromCart}
  >
    <img alt={'check mark'} src={checkmark} />
  </span>
);

export default enhance(CheckedBox);
